import { Outlet, useLocation } from 'react-router-dom'
import { useEffect, useState } from 'react'
import Sidebar from './Sidebar'
import Topbar from './Topbar'
import BackgroundGradient from './BackgroundGradient'
import ChangePasswordModal from '../components/ChangePasswordModal'
import { useAuth } from '../contexts/AuthContext'

export default function AppLayout() {
  const auth = useAuth()
  const [changeOpen, setChangeOpen] = useState(false)
  // Drawer del sidebar en móvil (<768px). Cerrado por defecto.
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const { pathname } = useLocation()

  const mustChange = auth.status === 'authenticated' && auth.user.mustChangePassword

  // Cierra el drawer al navegar (en móvil).
  useEffect(() => {
    setSidebarOpen(false)
  }, [pathname])

  // Bloquea el scroll del body cuando el drawer está abierto en móvil.
  // Cierra el drawer con Escape (a11y).
  useEffect(() => {
    if (!sidebarOpen) return
    const original = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setSidebarOpen(false)
    }
    document.addEventListener('keydown', onKey)
    return () => {
      document.body.style.overflow = original
      document.removeEventListener('keydown', onKey)
    }
  }, [sidebarOpen])

  return (
    <div className="h-screen font-heebo flex transition-colors duration-300 relative overflow-hidden t-primary">
      <BackgroundGradient />
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="relative z-10 flex-1 flex flex-col min-w-0 min-h-0">
        <Topbar
          onChangePassword={() => setChangeOpen(true)}
          onOpenSidebar={() => setSidebarOpen(true)}
        />
        {/* Shell de altura fija: sidebar + topbar quedan SIEMPRE visibles
            (el menú lateral ya no se pierde con listados largos).
            #app-main NO scrollea a propósito: es el destino de los modales
            fullscreen que hacen portal aquí con `absolute inset-0` (usan
            absolute porque `animate-slideUp` rompe `fixed`), y así lo cubren
            sin desplazarse. El scroll del contenido vive en el wrapper interior. */}
        <main id="app-main" className="flex-1 min-h-0 relative overflow-hidden">
          <div className="h-full overflow-y-auto overflow-x-hidden px-4 py-4 md:px-8 md:py-8">
            <Outlet />
          </div>
        </main>
      </div>
      {(mustChange || changeOpen) && (
        <ChangePasswordModal
          forced={mustChange}
          onClose={mustChange ? undefined : () => setChangeOpen(false)}
        />
      )}
    </div>
  )
}
